// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"ace4c69b","759":"d4eddc3a"}[chunkId] + ".chunk.css";
};